module.exports = __webpack_public_path__ + "img/rnd4.bfa52a57.jpg";